import { API_URL_LOGIN as ENDPOINT } from "../config/env";

export async function Login(data) {
    return fetch(`${ENDPOINT}login`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'post',
        body: JSON.stringify(data)
    }).then(res => res.json()).then(response => {
        return response;
    });
}

export async function ForgotPassword(data) {
    return fetch(`${ENDPOINT}forgot-password`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'post',
        body: JSON.stringify(data)
    }).then(res => res.json()).then(response => {
        return response;
    });
}

export async function ResetPassword(data) {
    return fetch(`${ENDPOINT}reset-password`, {
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'post',
        body: JSON.stringify(data)
    }).then(res => res.json()).then(response => {
        return response;
    });
}
